import useUserAgent from "./useUserAgent";

export default function usePaxWithBaggages() {
  const { isMobile } = useUserAgent();

  return { isPaxWithBaggages: !isMobile };
}
